import * as TYPES from "./Containers.types";

export const fetchAppHome = () => ({
  types: [
    TYPES.FETCH_APP_HOME,
    TYPES.FETCH_APP_HOME_SUCCESS,
    TYPES.FETCH_APP_HOME_FAIL,
  ],
  promise: (client) => client.get("/app-home"),
});

export const fetchTicker = () => ({
  types: [
    TYPES.FETCH_TICKER,
    TYPES.FETCH_TICKER_SUCCESS,
    TYPES.FETCH_TICKER_FAIL,
  ],
  promise: (client) => client.get("/ticker"),
});
